import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { ProductIcon } from '@components/ProductIcon'
import { formatDate } from '@util/date-util'

import { PageSection } from '../../../theme/components/PageSection'
import type { HoofdleidingProject } from '../../project/types/HoofdleidingProject'

export { DisciplineVerzamelingen }

const headerCells = [
  { id: 'disciplineCode', numeric: false, label: 'Discipline' },
  { id: 'netbeheerderCode', numeric: false, label: 'Netbeheerder' },
  { id: 'netbeheerderreferentie', numeric: false, label: 'Referentie' },
  { id: 'tracelengte', numeric: false, label: 'Tracélengte' },
  { id: 'technisch_gereed', numeric: false, label: 'Technisch gereed' },
] as const

type Props = {
  project: HoofdleidingProject
}

const DisciplineVerzamelingen = ({ project }: Props) => {
  const { disciplineVerzamelingen = [] } = project

  return (
    <PageSection heading="Disciplines" id="disciplines">
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Alle disciplines</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            <Table sx={{ padding: 0, backgroundColor: '#f7f7f7' }}>
              <TableHead>
                <TableRow>
                  {headerCells.map((headerCell) => (
                    <TableCell key={headerCell.id}>
                      {headerCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {disciplineVerzamelingen.map((dv) => (
                  <TableRow key={`${dv.disciplineCode}-${dv.netbeheerderCode}`}>
                    <TableCell>
                      <Grid
                        container
                        direction="row"
                        sx={{
                          alignItems: 'center',
                        }}
                      >
                        <ProductIcon
                          product={{
                            disciplineCode: dv.disciplineCode,
                            disciplineLabel: dv.disciplineLabel,
                            netbeheerderCode: dv.netbeheerderCode,
                          }}
                        />
                        <Typography style={{ fontSize: 'inherit' }}>
                          {dv.disciplineLabel}
                        </Typography>
                        {dv.isGeschovenNaarAannemer && (
                          <Chip
                            label="Geschoven naar aannemer"
                            variant="outlined"
                            sx={{ ml: 1, backgroundColor: 'white' }}
                            color="primary"
                          />
                        )}
                      </Grid>
                    </TableCell>
                    <TableCell>{dv.netbeheerderLabel}</TableCell>
                    <TableCell>{dv.referentie}</TableCell>
                    <TableCell>{dv.tracelengte}</TableCell>
                    <TableCell>
                      {dv.technischGereed && formatDate(dv.technischGereed)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Box>
    </PageSection>
  )
}
